export class RangeCalendarAvailableView {
    constructor(
        public minDate: Date,
        public maxDate: Date
    ) { }
}